import * as types from '../constants/settingConstants';

const initialState = {
  licenses: [],
  pagination: {},
  loading: false,
  error: null,
  createStatus: null,
  deleteStatus: null,
  updateStatus: null,
  statusChangeStatus: null,
  licenseUsage: [],
  usagePagination: {},
  usageLoading: false,
  usageStats: {}
};

const settingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CREATE_LICENSE_REQUEST:
    case types.GET_LICENSES_REQUEST:
    case types.DELETE_LICENSE_REQUEST:
    case types.UPDATE_LICENSE_REQUEST:
    case types.CHANGE_LICENSE_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case types.GET_LICENSE_USAGE_REQUEST:
      return {
        ...state,
        usageLoading: true,
        error: null
      };

    case types.CREATE_LICENSE_SUCCESS:
      return {
        ...state,
        loading: false,
        createStatus: action.payload.status,
        error: null
      };

    case types.GET_LICENSES_SUCCESS:
      return {
        ...state,
        loading: false,
        licenses: action.payload.response || action.payload,
        pagination: action.payload.pagination || {},
        createStatus: null,
        deleteStatus: null,
        updateStatus: null,
        statusChangeStatus: null,
        error: null
      };

    case types.DELETE_LICENSE_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteStatus: action.payload.status,
        error: null
      };

    case types.UPDATE_LICENSE_SUCCESS:
      return {
        ...state,
        loading: false,
        updateStatus: action.payload.status,
        error: null
      };

    case types.CHANGE_LICENSE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        statusChangeStatus: action.payload.status,
        error: null
      };

    case types.GET_LICENSE_USAGE_SUCCESS:
      return {
        ...state,
        usageLoading: false,
        licenseUsage: action.payload.data || [],
        usagePagination: action.payload.pagination || {},
        usageStats: action.payload.usage || {},
        error: null
      };

    case types.CREATE_LICENSE_FAILURE:
    case types.GET_LICENSES_FAILURE:
    case types.DELETE_LICENSE_FAILURE:
    case types.UPDATE_LICENSE_FAILURE:
    case types.CHANGE_LICENSE_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case types.GET_LICENSE_USAGE_FAILURE:
      return {
        ...state,
        usageLoading: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default settingReducer;